module.exports = __webpack_public_path__ + "img/branding.5e66671d.webp";